import menu from './menu';
import notifications from './notifications';

const pathname = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');
const connections = [
    { id: '', name: 'Export', link: '/admin' },
    { id: 'nz', name: 'New Zealand', link: '/admin/nz' },
    { id: 'my', name: 'Malaysia', link: '/admin/my' },
    { id: 'uk', name: 'United Kingdom', link: '/admin/uk' },
];

let connection = '';
if (pathname.split('/').length > 1) {
    connection += pathname.split('/')[1];
}

// fallback for front end
if (!_.find(connections, { id: connection })) {
    connection = false;
}

window.env.COUNTRY = connection;

export default {
    rootPath: window.env.APP_URL,
    apiPrefix: connection,
    apiFullPrefix: 'api' + (connection ? '/' + connection : ''),
    currentConnection: connection,
    connections: function() {
        if (_.get(this.user, 'role.country')) {
            return _.filter(connections, (conn) => conn.id == this.user.role.country);
        }

        return connections;
    },
    cmsTitle: window.env.APP_NAME,
    cmsPath: (connection ? `/admin/${connection}`  : '/admin'),
    routes: {
        default: '/dashboard',
        endpoints: {
            '/pages': {
                params: { filter: 'parent_id:$null' },
            },
            // '/panels': {
            //     params: { filter: 'content_id:$null' },
            // },
            '^/products': {
                params: { filter: 'id(opt):$has_option(active,1)' },
            },
            // '/categories': {
            //     params: { filter: 'parent_id:$null' },
            // },
            '/stores': {
                params: { filter: 'parent_id:$null' },
            },
            '/customers': {
                params: { filter: 'registered:1' }
            },
            '/news_posts': {
                params: { sort: 'available_at:desc' },
            },
            '/orders': {
                params: { sort: 'order_date:desc' }
            },
            '/enquiries': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
}
